import { render, staticRenderFns } from "./ClinicalUnitList.vue?vue&type=template&id=2bcce23c&scoped=true"
import script from "./ClinicalUnitList.vue?vue&type=script&lang=js"
export * from "./ClinicalUnitList.vue?vue&type=script&lang=js"
import style0 from "./ClinicalUnitList.vue?vue&type=style&index=0&id=2bcce23c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcce23c",
  null
  
)

export default component.exports